import Vue from 'vue'
import PersonalizedForm from './components/Form.vue'
import ProductMedia from './components/ProductMedia.vue'
import store from '@/store'
import Konva from 'konva'
import VueKonva from 'vue-konva'
import './less/style.less'
import jQuery from 'jquery'
import { get } from 'lodash'
import {
  isDevMode,
  loadCampaign,
  waitForCampaignData,
  treeToArray,
  checkWebp
} from './helper/helper'
import VueFormulate from '@braid/vue-formulate'
import ImageSwitch from './components/Formulate/ImageSwitch'
import ColorSwitch from './components/Formulate/ColorSwitch'
import ButtonGroup from './components/Formulate/ButtonGroup'
import ImageCropper from './components/Formulate/ImageCropper'
import ImageLyrics from './components/Formulate/ImageLyrics'
import * as VueGoogleMaps from "vue2-google-maps"
import ImageMap from './components/Formulate/ImageMap'
import ImageShape from './components/Formulate/ImageShape'
import ImageStarMap from './components/Formulate/ImageStarMap'
import ImageShapeMultiple from './components/Formulate/ImageShapeMultiple'
import ImageCutFace from './components/Formulate/ImageCutFace'
import ImageRemoveBackground from './components/Formulate/ImageRemoveBackground'
import TextBlur from './components/Formulate/TextBlur'
import ImageLyricsSpiral from './components/Formulate/ImageLyricsSpiral'
import ImageScrabble from './components/Formulate/ImageScrabble'
import ImageCalendarPicker from './components/Formulate/ImageCalendarPicker'
import ImageToy3D from './components/Formulate/ImageToy3D'
import ImageQR from './components/Formulate/ImageQR'
import ImageHandWriting from './components/Formulate/ImageHandWriting.vue'
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckSquare,
  faSpinner,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VModal from 'vue-js-modal'
import { AWS_API, AWS_API_CDN, CDN_URL, KEY_API_GOOGLE_MAP } from './config'
import feather from 'vue-icon'
import ImageMoonPhase from './components/Formulate/ImageMoonPhase.vue'
Vue.mixin({
  created() {
    this.$options.CDN_URL = CDN_URL
    this.$options.AWS_API = AWS_API
    this.$options.AWS_API_CDN = AWS_API_CDN
  }
})
Konva.pixelRatio = 1
Vue.use(VueKonva)
Vue.use(VModal, { dialog: true })
Vue.component('ImageSwitch', ImageSwitch)
Vue.use(VueGoogleMaps, {
  load: {
    key: KEY_API_GOOGLE_MAP,
    libraries: "places"
  }
});
// stuquery.js + virtualsky.js (Star Map only) are loaded on demand, in order,
// by ImageStarMap — see helper/virtualSky.js.
Vue.use(feather, 'v-icon')
Vue.use(VueFormulate, {
  library: {
    imageswitch: {
      component: ImageSwitch,
      slotProps: {
        component: ['showTitle']
      }
    },
    colorswitch: {
      component: ColorSwitch
    },
    buttongroup: {
      component: ButtonGroup
    },
    imagecropper: {
      component: ImageCropper,
      slotProps: {
        component: ['aspectRatio']
      }
    },
    imagelyrics: {
      component: ImageLyrics,
      slotProps: {
        component: ['colortextlyrics', 'shapes', 'fontfamilyurl', 'lyricIdParent']
      }
    },
    imagelyricsspiral: {
      component: ImageLyricsSpiral,
      slotProps: {
        component: ['name', 'fontJsonSpiral', 'lyricTextDefault','colorTextSpiral', 'typeSpiral', 'lyricIdParent', 'defaultFontSizeSpiralLyric', 'svgUrlSpiralLyric', 'minCharacters', 'maxCharacters']
      }
    },
    imagemap: {
      component: ImageMap,
      slotProps: {
        component: ['name', 'label', 'markericon', 'typemap', 'shapes', 'layerWidth', 'layerHeight', 'typecustom', 'dataTypeCustom', 'typeMapCustom', 'makerstatus', 'jsonDataMap', 'defaultCenterMap', 'defaultZoomMap', 'defaultCenterMarker', 'MapIdParent']
      }
    },
    imageshape: {
      component: ImageShape,
      slotProps: {
        component: ['shapes', 'aspectRatio', 'name']
      }
    },
    imageshapemultiple: {
      component: ImageShapeMultiple,
      slotProps: {
        component: ['shapes', 'aspectRatio', 'name', 'maxNumberImagesMulShape']
      }
    },
    imagestarmap: {
      component: ImageStarMap,
      slotProps: {
        component: ['shapes', 'aspectRatio', 'name', 'typeskystar', 'skystaridparent', 'transparentbackground', 'starcolor', 'backgroundcolors', 'rectangularType', 'scaleStars', 'scaleConstellations', 'scaleGrid']
      }
    },
    imagecutface: {
      component: ImageCutFace,
      slotProps: {
        component: ['aspectRatio', 'name', 'width', 'height', 'rotation', 'x', 'y', 'layer']
      }
    },
    textblur: {
      component: TextBlur,
      slotProps: {
        component: ['placeholder','maxlength', 'contentLayer', 'valueinput']
      }
    },
    imageremovebackground: {
      component: ImageRemoveBackground,
      slotProps: {
        component: ['aspectRatio', 'name', 'width', 'height', 'rotation', 'x', 'y', 'layer']
      }
    },
    imagescrabble: {
      component: ImageScrabble,
      slotProps: {
        component: ['name', "label", "aspectRatio", "configsScrabble", "valueDefault", "width", "height"]
      }
    },
    imagecalendarpicker: {
      component: ImageCalendarPicker,
      slotProps: {
        component: ['aspectRatio', 'name', 'label', "configsCalendar"]
      }
    },
    imagetoy3d: {
      component: ImageToy3D,
       slotProps: {
        component: ['aspectRatio', 'name', 'label', 'layer']
      }
    },
    imageqr: {
      component: ImageQR,
      slotProps: {
        component: ['aspectRatio', 'name', 'label', 'layer']
      }
    },
    imagehandwriting: {
      component: ImageHandWriting,
      slotProps: {
        component: ['aspectRatio', 'name', 'width', 'height', 'rotation', 'x', 'y', 'layer']
      }
    },
    imagemoonphase: {
      component: ImageMoonPhase,
      slotProps: {
        component: ['aspectRatio', 'name', 'label', 'layer', 'configsMoonPhase', 'artwork']
      }
    }
  },
  rules: {
    customImageRule: context => {
      return typeof context.value.base64 !== 'undefined'
    }
  }
})
library.add(faCheckSquare, faSpinner, faTimes)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
jQuery(async $ => {
  window.__WEBP = await checkWebp()
  var campaign
  if (isDevMode()) {
    await loadCampaign('hayooo.com', '70632')
      .then(data => {
        campaign = data.campaign
      })
      .catch(err => console.log(err))
  } else {
    // Lambda route cũ /<store>/<id> thay chuỗi này bằng dữ liệu campaign. Bản
    // client.js dùng chung (theme nạp từ CDN S3, không qua Lambda) giữ nguyên
    // chuỗi → lấy dữ liệu từ script /<store>/<id>.js. Không so sánh với chính
    // chuỗi placeholder: Lambda chỉ thay lần xuất hiện đầu tiên trong file.
    campaign = '--CAMPAIGN_PLACEHOLDER--'
    if (typeof campaign !== 'object') {
      campaign = await waitForCampaignData()
    }
  }

  // null: script /<store>/<id>.js báo lỗi API hoặc quá thời gian chờ.
  if (!campaign || typeof campaign !== 'object') {
    console.error('Invalid data')
    return
  }
  var platform = campaign.platform
  var product =
    platform === 'shopify'
      ? campaign.originProduct.product
      : campaign.originProduct
  store.dispatch('setPlatform', platform)
  if (platform === 'woocommerce') {
    if (Array.isArray(product.images)) {
      product.images.forEach((image, index) => {
        product.images[index].variant_ids = product.variants
          .filter(v => {
            return v.image && v.image.id === image.id
          })
          .map(v => v.id)
      })
    }
  }
  store.dispatch('setSiteURL', campaign.site.domain)
  if(campaign.bundledProducts != '' && campaign.bundledProducts != null){
    store.dispatch('setBundledProducts', JSON.parse(campaign.bundledProducts))
  }
  function setConfigRemoveBckgroudArtworks(artworks){
    artworks.forEach(e => {
      if(e.imageRemoveBackground || e.imageCutFace){
        if(!e.rotation){
          e.rotation = 0;
        }
        if(!e.scaleX){
          e.scaleX = 1;
        }
        if(!e.scaleY){
          e.scaleY = 1;
        }
        if(!e.offsetX){
          e.offsetX = 0;
        }
        if(!e.offsetY){
          e.offsetY = 0;
        }
      }
      if(e.type == "Group"){
        e.layers = setConfigRemoveBckgroudArtworks(e.layers);
      }
    });
    return artworks;
  }

  let setArtworks = campaign.artworks;
  setArtworks.forEach(artwork => {
    artwork.templates.forEach(layer => {
      layer.layers = setConfigRemoveBckgroudArtworks(layer.layers);
    });
  });

  store.dispatch('setProduct', product)
  store.dispatch('setVariants', campaign.variants)
  store.dispatch('setArtworks', setArtworks)
  store.dispatch('setMockups', campaign.mockups)
  //store.dispatch('setPrintAreas', product.print_areas)e
  campaign.artworks.forEach(artwork => {
    var personalized = {}
    treeToArray(artwork.templates[0].layers)
      .filter(
        layer =>
          layer.type === 'Option' ||
          (layer.personalized && layer.personalized.enable)
      )
      .forEach(layer => {
        switch (layer.type) {
          case 'Text':
            personalized[layer.id] = (
              layer.values.find(v => v.active) || layer.values[0]
            ).text
            break
          case 'Image':
            if (layer.personalized.type === 'clipartCategory') {
              if (layer.personalized.default) {
                personalized[layer.id] = layer.personalized.default.file
              } else {
                var defaultVal = layer.values.find(v => v.active)
                if (!defaultVal) {
                  defaultVal = layer.values[0]
                }
                personalized[layer.id] = defaultVal.file
              }
            } else {
              var defaultVal = layer.values.find(v => v.active)
              if (!defaultVal) {
                defaultVal = layer.values[0]
              }
              personalized[layer.id] = defaultVal.file
            }
            break
          case 'Option':
            var defaultVal = get(layer, 'options', []).find(op => op.default)
            if (!defaultVal) {
              personalized[layer.id] = get(layer, 'options[0].value')
            } else {
              personalized[layer.id] = defaultVal.value
            }
          default:
            break
        }
      })
    store.dispatch('setPersonalized', {
      artworkID: artwork.id,
      data: personalized
    })
  })

  campaign.artworks.forEach(artwork => {
    var personalizedText = []
    treeToArray(artwork.templates[0].layers)
      .filter(
        layer =>
          layer.type === 'Option' ||
          (layer.personalized && layer.personalized.enable)
      )
      .forEach(layer => {
        switch (layer.type) {
          case 'Text':
            let parent = null;
            if(layer.MapIdChild){
              parent = layer.MapIdChild;
            }else if(layer.skyStarIdChild){
              parent = layer.skyStarIdChild;
            }else if(layer.MapIdCoordinatesChild){
              parent = layer.MapIdCoordinatesChild
            }else if(layer.LyricSongTitleChildId){
              parent = layer.LyricSongTitleChildId
            } else if (layer.moonPhase_ChildID){
              parent = layer.moonPhase_ChildID;
            }

            let type = null;
            if(layer.textSkyAddress){
              type = "SkyAddress"
            }else if(layer.textSkyDate){
              type = "SkyDate"
            }else if(layer.textCoordinatesMap){
              type = "CoordinatesMap"
            }else if(layer.textLocationMap){
              type = "LocationMap"
            }else if(layer.textTitleSongLyric){
              type = "TitleSongLyric";
            }else if(layer.textCoordinatesStar){
              type = "CoordinatesStar";
            } else if (layer.textMoonPhaseDate){
              type = "textMoonPhaseDate"
            } else if (layer.textMoonPhaseAddress){
              type = "textMoonPhaseAddress"
            } else if (layer.textMoonPhaseCoordinates){
              type = "textMoonPhaseCoordinates"
            }
            let itemData = {
              'id': layer.id,
              'parent': parent,
              'value': (layer.values.find(v => v.active) || layer.values[0]).text,
              'type': type
            }
            personalizedText = [...personalizedText, itemData];
            break
          default:
            break
        }
      })
    store.commit('setPersonalizedText', personalizedText)
  })

  const VUE_PRODUCT_MEDIA = new Vue({
    el: '#omcustom-product-images',
    store,
    render: h => h(ProductMedia)
  })
  window.VUE_PRODUCT_MEDIA = VUE_PRODUCT_MEDIA;

  // new Vue({
  //   el: '#omcustom-product-images',
  //   store,
  //   render: h => h(ProductMedia)
  // })
  new Vue({
    el: '#omcustom-product-form',
    store,
    render: h => h(PersonalizedForm)
  })
})



// WEBPACK FOOTER //
// ./src/index.js